module.exports = __webpack_public_path__ + "asset/image-ic_category_20-6fc2442c0dc440b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_20.svg
// module id = 8qhh
// module chunks = 0